import { mapGetters } from 'vuex';
import Pagination from '@/components/pagination/index.vue';
import AssetsService from '../service.js';
import Service from '@/service/index.js';

export default {
  components: {
    Pagination
  },
  data() {
    return {
      activeName: '0',
      pageType: '',
      total: 0,
      tableList: [],
      Assetslist: [],
      projectType: '1',
      projectTypeArr: [],
      projectSubTypeArr: [],
      subTypeObj: {},
      searchForm: {
        pageNum: 1,
        pageSize: 5,
        type: 0
      },
      assetsStatusArr: [
        {code: 0, value: '可用'},
        {code: 1, value: '审核中'},
        {code: 2, value: '交易中'},
        {code: 3, value: '已流转'},
        {code: 4, value: '已到期'}
      ], // 资产状态
      tabList: [
        {
          name: '新添加资产',
          value: '0',
          total: 0,
          pageNum: 1,
          pageSize: 10,
          tableList: []
        },
        {
          name: '可流转资产',
          value: '1',
          total: 0,
          pageNum: 1,
          pageSize: 10,
          tableList: []
        },
        {
          name: '已流转资产',
          value: '2',
          total: 0,
          pageNum: 1,
          pageSize: 10,
          tableList: []
        },
        {
          name: '我的受让资产',
          value: '3',
          total: 0,
          pageNum: 1,
          pageSize: 10,
          tableList: []
        }
      ]
    };
  },

  created () {
    Service.getSelectList('PROJECT_TYPE').then(({ code, data }) => {
      if (code === '0') {
        this.projectTypeArr = data;

        this.projectTypeArr.map(item => {
          item.list.map(subItem => {
            this.subTypeObj[`${item.code}-${subItem.code}`] = subItem.value;
          });
        });
      }
    });
    this.getList();
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  methods: {
    handleClick() {
      this.searchForm.type = Number(this.activeName);
      this.pageNo = 1;
      this.getList();
      // if(tab.name === '0') {
      //   this.searchForm.type = 0;
      //   this.getList();
      // }
      // if(tab.name === '1') {
      //   this.searchForm.type = 1;
      //   this.getList();

      // }
      // if(tab.name === '2') {
      //   this.searchForm.type = 2;
      //   this.getList();
      // }
    },
    getList(page){
      if (page) {
        this.searchForm.pageNum = page.pageNo;
        this.searchForm.pageSize = page.pageSize;
      } else {
        this.searchForm.pageNum = 1;
        this.searchForm.pageSize = 5;
      }
      AssetsService.getAssetsList(this.searchForm).then(res => {
        // console.log(res, 111);
        if (res.code === '0') {
          this.total = res.data.total;
          this.tableList = res.data.list;
          // this.projectTypeArr.forEach(res => {
          //   this.Assetslist.push(res.list);
          // });
          // console.log(this.Assetslist, 111);
        } else {
          errorMessage(res.reason);
        }
      }, (error) => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    },
    // 详情
    goDetails(item) {
      this.$router.push({path: '/person-center/my-assets/detail', query: {assetsCode: item.assetsCode}});
    },
    // 申请流转
    goApply(item) {
      console.log(item);
      this.$router.push({path: '/publish-project/project-info', query: {assetsCode: item.assetsCode}});
    },
    // 添加资产
    addAssets() {
      this.$router.push({path: '/person-center/my-assets/add'});
    }
  }
};

